var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "payForm",
      attrs: {
        model: _vm.form,
        "label-width": "120px",
        rules: _vm.rules,
        size: "small",
        autocomplete: "off",
      },
    },
    [
      _c(
        "el-form-item",
        { attrs: { label: "支付通道", prop: "payChannel" } },
        [
          _c(
            "el-select",
            {
              attrs: { placeholder: "请选择支付通道" },
              model: {
                value: _vm.form.payChannel,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "payChannel", $$v)
                },
                expression: "form.payChannel",
              },
            },
            _vm._l(_vm.payChannelOptions, function (item) {
              return _c("el-option", {
                key: item.value,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "商户号", prop: "merchantNo" } },
        [
          _c("el-input", {
            attrs: {
              name: "fakeMerchantNo",
              placeholder: "请输入商户号",
              autocomplete: "new-password",
            },
            model: {
              value: _vm.form.merchantNo,
              callback: function ($$v) {
                _vm.$set(_vm.form, "merchantNo", $$v)
              },
              expression: "form.merchantNo",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "商户私钥", prop: "merchantKey" } },
        [
          _c("el-input", {
            attrs: {
              name: "fakeMerchantKey",
              placeholder: "请输入商户私钥",
              "show-password": "",
              autocomplete: "new-password",
            },
            model: {
              value: _vm.form.merchantKey,
              callback: function ($$v) {
                _vm.$set(_vm.form, "merchantKey", $$v)
              },
              expression: "form.merchantKey",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "商户公钥", prop: "publicMerchantKey" } },
        [
          _c("el-input", {
            attrs: { placeholder: "请输入商户公钥" },
            model: {
              value: _vm.form.publicMerchantKey,
              callback: function ($$v) {
                _vm.$set(_vm.form, "publicMerchantKey", $$v)
              },
              expression: "form.publicMerchantKey",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "支付通道公钥", prop: "payChannelPublicKey" } },
        [
          _c("el-input", {
            attrs: { placeholder: "请输入商户公钥" },
            model: {
              value: _vm.form.payChannelPublicKey,
              callback: function ($$v) {
                _vm.$set(_vm.form, "payChannelPublicKey", $$v)
              },
              expression: "form.payChannelPublicKey",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "证书序列号", prop: "certSerialNo" } },
        [
          _c("el-input", {
            attrs: { placeholder: "请输入证书序列号" },
            model: {
              value: _vm.form.certSerialNo,
              callback: function ($$v) {
                _vm.$set(_vm.form, "certSerialNo", $$v)
              },
              expression: "form.certSerialNo",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form-item",
        { attrs: { label: "证书路径", prop: "certPath" } },
        [
          _c("el-input", {
            attrs: { placeholder: "请输入证书路径" },
            model: {
              value: _vm.form.certPath,
              callback: function ($$v) {
                _vm.$set(_vm.form, "certPath", $$v)
              },
              expression: "form.certPath",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-form-item", { attrs: { label: "扩展配置" } }, [
        _c(
          "div",
          { staticClass: "kv-box" },
          [
            _vm._l(_vm.extraList, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "kv-row" },
                [
                  _c("el-input", {
                    staticStyle: { width: "40%" },
                    attrs: { placeholder: "配置名" },
                    model: {
                      value: item.key,
                      callback: function ($$v) {
                        _vm.$set(item, "key", $$v)
                      },
                      expression: "item.key",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-input", {
                    staticStyle: { width: "45%", "margin-left": "10px" },
                    attrs: { placeholder: "配置值" },
                    model: {
                      value: item.value,
                      callback: function ($$v) {
                        _vm.$set(item, "value", $$v)
                      },
                      expression: "item.value",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-button", {
                    staticStyle: { "margin-left": "6px" },
                    attrs: { type: "text", icon: "el-icon-delete" },
                    on: {
                      click: function ($event) {
                        return _vm.removeExtra(index)
                      },
                    },
                  }),
                ],
                1
              )
            }),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticStyle: { "margin-top": "6px" },
                attrs: {
                  type: "primary",
                  size: "mini",
                  plain: "",
                  icon: "el-icon-plus",
                },
                on: { click: _vm.addExtra },
              },
              [_vm._v("\n        添加配置\n      ")]
            ),
          ],
          2
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          staticStyle: { "text-align": "right", "margin-top": "10px" },
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.$emit("cancel")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.loading },
              on: { click: _vm.submit },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }